var $ = require("jquery");
import moment from "moment/moment.js";

const WEEKDAYS = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
const MAX_VISIBLE_EVENTS = 3;

moment.locale('de');

$(document).on('turbo:load', function() {
  if (!window.location.pathname.includes('abfallkalender')) {
    return;
  }

  const calendarElement = document.querySelector('#calendar');
  if (!calendarElement) {
    return;
  }

  const categories = readStoredValue('garbage_types', []);
  const garbageDates = readStoredValue('garbage_dates', {});
  const garbageDistrict = readStoredValue('garbage_district', null);
  const calendarTitle = garbageDistrict && garbageDistrict.name
    ? 'Abfallkalender ' + garbageDistrict.name
    : 'Abfallkalender';
  const categoryMap = new Map(
    (Array.isArray(categories) ? categories : []).map(function(category) {
      return [String(category.id), normaliseCategory(category)];
    })
  );
  const dates = (
    garbageDates &&
    garbageDates.data &&
    Array.isArray(garbageDates.data.data)
  ) ? garbageDates.data.data : [];
  const events = dates.reduce(function(result, item) {
    const category = categoryMap.get(String(item.garbage_type_id));
    const pickup = moment(item.pickup);

    if (category && pickup.isValid()) {
      result.push({
        kindId: category.id,
        name: category.name,
        color1: category.color1,
        color2: category.color2,
        pickup: pickup
      });
    }

    return result;
  }, []).sort(function(first, second) {
    return first.pickup.valueOf() - second.pickup.valueOf();
  });

  new Calendar(calendarElement, events, Array.from(categoryMap.values()), calendarTitle);
});

function Calendar(element, events, categories, title) {
  this.el = element;
  this.events = events;
  this.categories = categories;
  this.title = title;
  this.today = moment().startOf('day');
  this.current = this.today.clone().startOf('month');
  this.selectedDay = this.today.clone();
  this.activeKindIds = new Set(categories.map(function(category) {
    return category.id;
  }));

  this.el.classList.add('garbage-calendar');
  this.el.setAttribute('aria-label', this.title);
  this.render();
}

Calendar.prototype.render = function(direction) {
  this.el.innerHTML = '';
  this.el.appendChild(this.renderHeader());
  this.el.appendChild(this.renderWeekdays());
  this.el.appendChild(this.renderMonth(direction));
  this.el.appendChild(this.renderDayDetails());

  if (this.categories.length) {
    this.el.appendChild(this.renderFilters());
  }
};

Calendar.prototype.renderHeader = function() {
  const self = this;
  const header = createElement('div', 'calendar-header');
  const previousButton = createIconButton(
    'icon-arrow-left',
    'Vorheriger Monat',
    'calendar-nav-button'
  );
  const nextButton = createIconButton(
    'icon-arrow-right',
    'Nächster Monat',
    'calendar-nav-button'
  );
  const heading = createElement('div', 'calendar-heading');
  const contextTitle = createElement('h2', 'calendar-context-title', this.title);
  const title = createElement('h3', 'calendar-title', this.current.format('MMMM YYYY'));
  const meta = createElement('div', 'calendar-meta');
  const summary = createElement(
    'span',
    'calendar-summary',
    formatEventCount(this.eventsInCurrentMonth().length)
  );
  const nextEvent = this.nextActiveEvent();
  const nextPickup = createElement(
    'span',
    'calendar-next-pickup',
    nextEvent
      ? 'Nächster: ' + nextEvent.pickup.format('D. MMM') + ' · ' + nextEvent.name
      : 'Keine weiteren Termine'
  );
  const todayButton = createElement('button', 'calendar-today-button', 'Heute');

  title.setAttribute('aria-live', 'polite');
  previousButton.dataset.calendarAction = 'previous';
  nextButton.dataset.calendarAction = 'next';
  todayButton.type = 'button';
  todayButton.disabled = this.current.isSame(this.today, 'month');
  todayButton.dataset.calendarAction = 'today';

  previousButton.addEventListener('click', function() {
    self.changeMonth(-1);
  });
  nextButton.addEventListener('click', function() {
    self.changeMonth(1);
  });
  todayButton.addEventListener('click', function() {
    self.current = self.today.clone().startOf('month');
    self.selectedDay = self.today.clone();
    self.render('today');
    self.focusSelectedDay();
  });

  heading.appendChild(contextTitle);
  heading.appendChild(title);
  meta.appendChild(summary);
  meta.appendChild(nextPickup);
  heading.appendChild(meta);
  header.appendChild(previousButton);
  header.appendChild(heading);
  header.appendChild(todayButton);
  header.appendChild(nextButton);

  return header;
};

Calendar.prototype.renderWeekdays = function() {
  const row = createElement('div', 'calendar-weekdays');

  WEEKDAYS.forEach(function(weekday) {
    row.appendChild(createElement('span', 'calendar-weekday', weekday));
  });

  return row;
};

Calendar.prototype.renderMonth = function(direction) {
  const self = this;
  const month = createElement(
    'div',
    'calendar-month' + (direction ? ' calendar-month--' + direction : '')
  );
  const firstVisibleDay = this.current.clone().startOf('isoWeek');
  const daysNeeded = this.current.clone().endOf('month').diff(firstVisibleDay, 'days') + 1;
  const visibleDayCount = daysNeeded > 35 ? 42 : 35;

  for (let index = 0; index < visibleDayCount; index += 1) {
    const day = firstVisibleDay.clone().add(index, 'days');
    month.appendChild(this.renderDay(day, function() {
      const previousMonth = self.current.clone();
      self.selectedDay = day.clone();
      self.current = day.clone().startOf('month');
      self.render(
        previousMonth.isSame(self.current, 'month')
          ? undefined
          : (self.current.isAfter(previousMonth) ? 'next' : 'previous')
      );
      self.focusSelectedDay();
    }));
  }

  return month;
};

Calendar.prototype.renderDay = function(day, onSelect) {
  const self = this;
  const events = this.eventsForDay(day);
  const dayButton = createElement('button', 'calendar-day');
  const dayNumber = createElement('span', 'calendar-day-number', day.format('D'));
  const markers = createElement('span', 'calendar-day-events');

  dayButton.type = 'button';
  dayButton.dataset.date = day.format('YYYY-MM-DD');
  dayButton.setAttribute(
    'aria-label',
    day.format('dddd, D. MMMM YYYY') + ', ' + formatEventCount(events.length)
  );

  if (!day.isSame(this.current, 'month')) {
    dayButton.classList.add('calendar-day--other');
  }
  if (day.isSame(this.today, 'day')) {
    dayButton.classList.add('calendar-day--today');
    dayNumber.setAttribute('aria-current', 'date');
  }
  if (this.selectedDay && day.isSame(this.selectedDay, 'day')) {
    dayButton.classList.add('calendar-day--selected');
  }
  if (events.length) {
    dayButton.classList.add('calendar-day--has-events');
  }

  events.slice(0, MAX_VISIBLE_EVENTS).forEach(function(event) {
    const marker = createElement('span', 'calendar-event-marker');
    marker.title = event.name;
    marker.style.setProperty('--event-color-1', event.color1);
    marker.style.setProperty('--event-color-2', event.color2);
    marker.appendChild(createElement('span', 'calendar-event-name', event.name));
    markers.appendChild(marker);
  });

  if (events.length > MAX_VISIBLE_EVENTS) {
    markers.appendChild(
      createElement(
        'span',
        'calendar-event-overflow',
        '+' + (events.length - MAX_VISIBLE_EVENTS)
      )
    );
  }

  dayButton.appendChild(dayNumber);
  dayButton.appendChild(markers);
  dayButton.addEventListener('click', onSelect);
  dayButton.addEventListener('keydown', function(event) {
    const dayOffsets = {
      ArrowLeft: -1,
      ArrowRight: 1,
      ArrowUp: -7,
      ArrowDown: 7
    };
    const offset = dayOffsets[event.key];

    if (!offset) {
      return;
    }

    event.preventDefault();
    const targetDay = day.clone().add(offset, 'days');
    const previousMonth = self.current.clone();
    self.selectedDay = targetDay;
    self.current = targetDay.clone().startOf('month');
    self.render(
      previousMonth.isSame(self.current, 'month')
        ? undefined
        : (self.current.isAfter(previousMonth) ? 'next' : 'previous')
    );
    self.focusSelectedDay();
  });

  return dayButton;
};

Calendar.prototype.renderDayDetails = function() {
  const details = createElement('section', 'calendar-details');
  const heading = createElement('div', 'calendar-details-heading');

  if (!this.selectedDay) {
    heading.appendChild(createElement('h4', 'calendar-details-title', 'Tag auswählen'));
    details.appendChild(heading);
    details.appendChild(
      createElement(
        'p',
        'calendar-details-empty',
        'Wähle einen Tag aus, um die Abholtermine zu sehen.'
      )
    );
    return details;
  }

  const events = this.eventsForDay(this.selectedDay);
  heading.appendChild(
    createElement(
      'h4',
      'calendar-details-title',
      this.selectedDay.format('dddd, D. MMMM YYYY')
    )
  );
  heading.appendChild(
    createElement('span', 'calendar-details-count', formatEventCount(events.length))
  );
  details.appendChild(heading);

  if (!events.length) {
    details.appendChild(
      createElement('p', 'calendar-details-empty', 'Keine Abholung an diesem Tag.')
    );
    return details;
  }

  const list = createElement('ul', 'calendar-details-list');
  events.forEach(function(event) {
    const item = createElement('li', 'calendar-details-item');
    const swatch = createElement('span', 'calendar-details-swatch');
    swatch.style.setProperty('--event-color-1', event.color1);
    swatch.style.setProperty('--event-color-2', event.color2);
    item.appendChild(swatch);
    item.appendChild(createElement('span', 'calendar-details-name', event.name));
    list.appendChild(item);
  });
  details.appendChild(list);

  return details;
};

Calendar.prototype.renderFilters = function() {
  const self = this;
  const filters = createElement('section', 'calendar-filters');
  const header = createElement('div', 'calendar-filters-header');
  const heading = createElement('div');
  const title = createElement('h4', 'calendar-filters-title', 'Abfallarten');
  const status = createElement(
    'span',
    'calendar-filters-status',
    this.activeKindIds.size + ' von ' + this.categories.length + ' aktiv'
  );
  const toggleButton = createElement(
    'button',
    'calendar-filter-toggle',
    this.activeKindIds.size === this.categories.length ? 'Keine auswählen' : 'Alle auswählen'
  );
  const list = createElement('div', 'calendar-filter-list');

  toggleButton.type = 'button';
  toggleButton.dataset.calendarAction = 'toggle-filters';
  toggleButton.addEventListener('click', function() {
    if (self.activeKindIds.size === self.categories.length) {
      self.activeKindIds.clear();
    } else {
      self.categories.forEach(function(category) {
        self.activeKindIds.add(category.id);
      });
    }
    self.render('filter');
    self.focusControl('toggle-filters');
  });

  heading.appendChild(title);
  heading.appendChild(status);
  header.appendChild(heading);
  header.appendChild(toggleButton);
  filters.appendChild(header);

  this.categories.forEach(function(category, index) {
    const label = createElement('label', 'calendar-filter-chip');
    const input = createElement('input', 'calendar-filter-input');
    const control = createElement('span', 'calendar-filter-control');
    const swatch = createElement('span', 'calendar-filter-swatch');
    const name = createElement('span', 'calendar-filter-name', category.name);

    input.type = 'checkbox';
    input.checked = self.activeKindIds.has(category.id);
    input.id = 'calendar-filter-' + index;
    input.value = category.id;
    input.dataset.kindId = category.id;
    swatch.style.setProperty('--event-color-1', category.color1);
    swatch.style.setProperty('--event-color-2', category.color2);

    input.addEventListener('change', function() {
      if (input.checked) {
        self.activeKindIds.add(category.id);
      } else {
        self.activeKindIds.delete(category.id);
      }
      self.render('filter');
      self.focusFilter(category.id);
    });

    control.appendChild(swatch);
    control.appendChild(name);
    label.appendChild(input);
    label.appendChild(control);
    list.appendChild(label);
  });

  filters.appendChild(list);
  return filters;
};

Calendar.prototype.eventsForDay = function(day) {
  const activeKindIds = this.activeKindIds;

  return this.events.filter(function(event) {
    return activeKindIds.has(event.kindId) && event.pickup.isSame(day, 'day');
  });
};

Calendar.prototype.eventsInCurrentMonth = function() {
  const activeKindIds = this.activeKindIds;
  const current = this.current;

  return this.events.filter(function(event) {
    return activeKindIds.has(event.kindId) && event.pickup.isSame(current, 'month');
  });
};

Calendar.prototype.nextActiveEvent = function() {
  const activeKindIds = this.activeKindIds;
  const today = this.today;

  return this.events.find(function(event) {
    return activeKindIds.has(event.kindId) && !event.pickup.isBefore(today, 'day');
  });
};

Calendar.prototype.changeMonth = function(offset) {
  this.current.add(offset, 'months').startOf('month');
  this.selectedDay = null;
  this.render(offset > 0 ? 'next' : 'previous');
  this.focusControl(offset > 0 ? 'next' : 'previous');
};

Calendar.prototype.focusSelectedDay = function() {
  if (!this.selectedDay) {
    return;
  }

  const selectedDate = this.selectedDay.format('YYYY-MM-DD');
  window.requestAnimationFrame(function() {
    const selectedDay = document.querySelector(
      '#calendar .calendar-day[data-date="' + selectedDate + '"]'
    );
    if (selectedDay) {
      selectedDay.focus({ preventScroll: true });
    }
  });
};

Calendar.prototype.focusControl = function(action) {
  window.requestAnimationFrame(function() {
    const control = document.querySelector(
      '#calendar [data-calendar-action="' + action + '"]'
    );
    if (control) {
      control.focus({ preventScroll: true });
    }
  });
};

Calendar.prototype.focusFilter = function(kindId) {
  window.requestAnimationFrame(function() {
    const filters = document.querySelectorAll('#calendar .calendar-filter-input');
    const filter = Array.prototype.find.call(filters, function(input) {
      return input.dataset.kindId === kindId;
    });
    if (filter) {
      filter.focus({ preventScroll: true });
    }
  });
};

function normaliseCategory(category) {
  return {
    id: String(category.id),
    name: category.name || 'Unbekannte Abfallart',
    color1: rgbIntegerToHex(category.color1_rgb),
    color2: rgbIntegerToHex(category.color2_rgb)
  };
}

function rgbIntegerToHex(value) {
  return '#' + String('000000' + Math.abs(Number(value) || 0).toString(16)).slice(-6);
}

function readStoredValue(key, fallback) {
  try {
    const value = window.localStorage.getItem(key);
    return value ? JSON.parse(value) : fallback;
  } catch (error) {
    return fallback;
  }
}

function formatEventCount(count) {
  return count + (count === 1 ? ' Termin' : ' Termine');
}

function createIconButton(iconClass, label, className) {
  const button = createElement('button', className);
  const icon = createElement('span', iconClass);

  button.type = 'button';
  button.setAttribute('aria-label', label);
  icon.setAttribute('aria-hidden', 'true');
  button.appendChild(icon);

  return button;
}

function createElement(tagName, className, text) {
  const element = document.createElement(tagName);

  if (className) {
    element.className = className;
  }
  if (text !== undefined) {
    element.textContent = text;
  }

  return element;
}
